import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../components/MainLayout';
import { ManagerApprovalInbox } from '../components/ManagerApprovalInbox';
import { CheckSquare, BarChart3 } from 'lucide-react';

const ManagerApprovals = () => {
  const navigate = useNavigate();
  return (
    <MainLayout>
      <div data-testid="manager-approvals-page" className="space-y-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="text-xl font-bold text-slate-900 flex items-center gap-2">
              <CheckSquare className="w-5 h-5 text-[#0052FF]" /> My Team Approvals
            </h1>
            <p className="text-xs text-slate-500 mt-0.5">
              Local Conveyance, Outstation Conveyance, Regularization, Leave, Permission, Comp-Off and other assigned requests from employees mapped to you. Approve, reject or send back with remarks.
            </p>
          </div>
          <button
            data-testid="view-consolidated-report-btn"
            onClick={() => navigate('/manager/approval-report')}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold bg-[#0052FF] text-white hover:bg-blue-600 shadow-sm transition"
          >
            <BarChart3 className="w-4 h-4" /> Consolidated Approval Report
          </button>
        </div>
        <ManagerApprovalInbox />
      </div>
    </MainLayout>
  );
};

export default ManagerApprovals;
